import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Loader2, Database, CheckCircle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export default function DatabasePopulator() {
  const [loading, setLoading] = useState(false);
  const [populated, setPopulated] = useState(false);
  const [error, setError] = useState("");

  const populateDatabase = async () => {
    setLoading(true);
    setError("");

    try {
      const { data, error } = await supabase.functions.invoke('populate-db');
      
      if (error) {
        throw error;
      }

      if (data?.success) {
        setPopulated(true);
        toast.success(`Base de datos poblada exitosamente! ${data.users_created} organizadores creados.`);
      }
    } catch (err: any) {
      setError(err.message || "Error al poblar la base de datos");
      toast.error("Error al poblar la base de datos");
    } finally {
      setLoading(false);
    }
  };

  if (populated) {
    return (
      <Card className="w-full max-w-md mx-auto">
        <CardContent className="p-6 text-center">
          <CheckCircle className="h-12 w-12 text-green-600 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            ¡Base de datos poblada!
          </h3>
          <p className="text-gray-600">
            La aplicación ahora tiene datos de ejemplo. Puedes navegar por las diferentes secciones.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Database className="h-5 w-5" />
          Configurar Base de Datos
        </CardTitle>
        <CardDescription>
          Poblar la base de datos con datos de ejemplo para probar la aplicación
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {error && (
          <Alert variant="destructive">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}
        
        <div className="space-y-2">
          <p className="text-sm text-gray-600">
            Esto creará:
          </p>
          <ul className="text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>4 organizadores de ejemplo</li>
            <li>3 clubs deportivos</li>
            <li>Eventos y torneos de muestra</li>
            <li>Premios y categorías</li>
          </ul>
        </div>

        <Button 
          onClick={populateDatabase} 
          disabled={loading}
          className="w-full"
        >
          {loading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Poblando base de datos...
            </>
          ) : (
            <>
              <Database className="mr-2 h-4 w-4" />
              Poblar Base de Datos
            </>
          )}
        </Button>
      </CardContent>
    </Card>
  );
}